<template>
  <ChevronLeftIcon class="icon"/>
</template>

<script>
import { ChevronLeftIcon } from '@heroicons/vue/outline'

export default {
  components: { ChevronLeftIcon }
}
</script>

<style scoped>
.icon {
  height: 2rem;
  vertical-align: text-bottom;
  width: 2rem;
}
</style>
